import { ClockifyTimeEntryTimeChangedAlert } from "./clockifyTimeChangedAlert/ClockifyTimeEntryTimeChangedAlert";
import { ClockifyTimeEntryTimeChangedAlertResponse } from "./clockifyTimeChangedAlert/ClockifyTimeEntryTimeChangedAlertResponse";

export class ClockifyTimeEntryChangedMapper {
  mapToClockifyTimeEntryChangedAlert(
    response: ClockifyTimeEntryTimeChangedAlertResponse
  ): ClockifyTimeEntryTimeChangedAlert {
    return {
      id: response.id,
      clockifyTimeEntryId: response.clockifyTimeEntryId,
      from: response.from,
      to: response.to,
      dateCreated: response.dateCreated,
      dateModified: response.dateModified,
    };
  }
}
